import React from "react";
import "../styles/Navbar.css";
// import { Link } from "react-router-dom";

function Navbar() {
  return (
    <div className="navbar">
      <div className="nav-title">Zahraa's Video Recommendations</div>
    </div>
  );
}

export default Navbar;
